import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import {InsertDriveFileOutlined} from '@material-ui/icons';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import {lerErroDeArquivo, salvarBlob} from '../../components/downloadArquivo.js';
import {NOME_ARQUIVO_CADASTRO_BOLSISTAS} from '../../components/relatorio/relatorios.js';
import useCarregamentoPagina from '../../components/useCarregamentoPagina.js';
import useFetch from '../../../../hooks/useFetch.js';
import {URL_RELATORIO_CADASTRO_BOLSISTAS} from '../../../../constants/index.js';

const PARAMS_VAZIOS = {};

const useStyles = makeStyles(() => ({
    root: {
        width: 500,
        maxWidth: '100%'
    }
}));

/*
 * Relatório de Cadastro dos Bolsistas (módulo RELMENU): sem filtros; o back devolve o Excel
 * (.xls) com o cadastro de todos os bolsistas, que é baixado (sem visualizador).
 */
export default function DialogRelatorioCadastroBolsistas(props) {
    const {open, onClose} = props;
    const classes = useStyles();
    const [baixar, gerando] = useFetch({returnInnerLoadingState: true, responseType: 'blob'});

    const emitir = () => baixar(URL_RELATORIO_CADASTRO_BOLSISTAS, PARAMS_VAZIOS,
        blob => {
            salvarBlob(blob, NOME_ARQUIVO_CADASTRO_BOLSISTAS);
            onClose();
        },
        (erro, tratarErro) => lerErroDeArquivo(erro).then(tratarErro));

    // Loading pelo LoadingModal global.
    useCarregamentoPagina(gerando);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-relatorio-cadastro-bolsistas-titulo'>
            <DialogTitle id='dialog-relatorio-cadastro-bolsistas-titulo'>Relatório de Cadastro dos Bolsistas</DialogTitle>
            <DialogContent>
                <Typography variant='body2'>
                    Gera o Excel (.xls) com o cadastro de todos os bolsistas (view SAF_V_TBOLS). Pode levar alguns instantes.
                </Typography>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Cancelar</TextButton>
                <ContainedButton startIcon={<InsertDriveFileOutlined/>} disabled={gerando} onClick={emitir}>
                    Emitir Relatório
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogRelatorioCadastroBolsistas.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
